export const MARKET_TABS = [
    { label: "Основні", value: "general", count: 20 },
    { label: "Позапланові", value: "extra", count: 20 },
    { label: "Завершені", value: "completed", count: 20 },
];

export const SORT_OPTIONS = [
    { value: "route", label: "по маршруту" },
    { value: "fop-asc", label: "по контрагенту: А - Я ↓" },
    { value: "fop-desc", label: "по контрагенту: Я - А ↑" },
    { value: "address-asc", label: "по адресі: А - Я ↓" },
    { value: "address-desc", label: "по адресі: Я - А ↑" },
];
